import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import advertising from "./components/advertising";
import eventBinding from "./components/eventBinding";
import eventm from "./components/eventm";
import eventReturn from "./components/eventReturn";
import predefined from "./components/predefined";
import productBinding from "./components/productBinding";
import preDefinedEvents from "./components/preDefinedEvents";
import splitReturnedAmount from "./components/splitReturnedAmount";
import returnCredentialMement from "./components/returnCredentialMement";
import { tabulation } from "@/mixins/index";
export default {
  name: "backhaul",
  mixins: [tabulation],
  components: {
    advertising: advertising,
    eventBinding: eventBinding,
    eventm: eventm,
    eventReturn: eventReturn,
    predefined: predefined,
    productBinding: productBinding,
    preDefinedEvents: preDefinedEvents,
    splitReturnedAmount: splitReturnedAmount,
    returnCredentialMement: returnCredentialMement
  },
  data: function data() {
    return {
      activeIndex: 'advertising'
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    modelChange: function modelChange(e) {
      this.activeIndex = e;
      this.$refs[e].comInit && this.$refs[e].comInit();
    }
  }
};